import React from 'react'

import { Root } from './ThemesPanel.styled.js'

import QuestionBox from './QuestionBox'

const ThemesPanel = ({ questions, answers, selectedQuestion, setQuestion }) => {
  return (
    <Root>
      {questions.map(question => (
        <QuestionBox
          key={question.questionId}
          question={question}
          selected={question.id === selectedQuestion}
          correct={answers[question.id] === question.correct}
          selectedTheme={true}
          setQuestion={() => setQuestion(question.id)}
        ></QuestionBox>
      ))}
    </Root>
  )
}

export default ThemesPanel
